import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "fixed top-0 left-0 w-full text-center z-[9999] transition-top duration-400 ease-in-out",
  style: {
    "top": "3.75rem"
  }
};
const _hoisted_2 = {
  class: "inline-block mb-3 mx-4"
};
const _hoisted_3 = {
  class: "inline-flex items-center px-4 py-2 text-left font-normal rounded-lg shadow-md bg-white dark:bg-gray-800 text-slate-800 dark:text-slate-100 border border-slate-300 dark:border-gray-700",
  style: {
    "background-color": "#5A7B94"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createBlock(_Transition, {
    name: "message-slide"
  }, {
    default: _withCtx(() => [_withDirectives(_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("span", null, _toDisplayString($props.config.content), 1)])])], 512), [[_vShow, $data.visible]])]),
    _: 1
  });
}